import { ApiClient } from "./api-client";

export async function getFiltersMakeBookingPage() {
  return ApiClient.getInstance().get('/filter/makeBookingPage').catch((error) => {
    console.error('Error fetching make booking filters', error);
    throw error;
  });
}

export async function getFiltersBookingsPage() {
  return ApiClient.getInstance().get('/filter/bookings').catch((error) => {
    console.error('Error fetching make booking filters', error);
    throw error;
  });
}

export async function getFiltersBookingsAdminPage() {
  return ApiClient.getInstance().get('/filter/bookingsAdmin').catch((error) => {
    console.error('Error fetching make booking filters', error);
    throw error;
  });
}

export async function getFiltersUserAdminPage() {
  return ApiClient.getInstance().get('/filter/usersAdmin').catch((error) => {
    console.error('Error fetching user filters', error);
    throw error;
  });
}